<template>
  <Breadcrumb
    :home="home"
    :model="breadcrumbItems"
    :style="{
      background: 'transparent',
      border: 'none',
      padding: '0 0 1rem 0',
    }"
  />
</template>

<script>
export default {
  name: 'AppBreadcrumb',
  props: {
    items: Array,
  },
  data() {
    return {
      home: { icon: 'pi pi-home', to: '/' },
    };
  },
  computed: {
    breadcrumbItems() {
      return (this.items || []).map(({ label, routeName, routeParams }) => {
        if (!routeName) {
          return { label };
        }
        if (routeParams) {
          const command = () => {
            this.$router.push({
              name: routeName,
              params: routeParams,
            });
          };
          return { label, command };
        }
        const { href: to } = this.$router.resolve({
          name: routeName,
        });
        return { label, to };
      });
    },
  },
};
</script>

<style>
</style>
